import React from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import PsychologyIcon from "@mui/icons-material/Psychology";

const Banner = () => {
  return (
    <Box marginTop={{ xs: "25%", sm: "5%" }}>
      <Box alignItems={"center"} width={"100%"}>
        <Typography
          variant={"h3"}
          fontWeight={700}
          textAlign={"center"}
          color={"#fff"}
        >
          Get In Touch
        </Typography>
        <Stack
          spacing={2}
          width={{ xs: "60%", sm: "20%" }}
          paddingTop={{ xs: "5%", sm: "1%" }}
          //   display={{ xs: "none", sm: "block" }}
        >
          <Breadcrumbs
            separator={
              <PsychologyIcon
                fontSize="medium"
                sx={{
                  color: "#fff",
                }}
              />
            }
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/"
              sx={{
                color: "#fff",
                fontSize: "18px",
                "&:hover": { color: "#F5EFE7" },
              }}
            >
              Home
            </Link>
            <Typography
              fontWeight={700}
              key="2"
              sx={{
                color: "#D8C4B6",
                fontSize: "18px",
                fontStyle: "bold",
              }}
            >
              Contact Us
            </Typography>
          </Breadcrumbs>
        </Stack>
      </Box>
    </Box>
  );
};

export default Banner;
